export default "__VITE_ASSET__BOBVeJxh__"